import React, { useEffect, useState } from 'react';
import {
  getAllCapteurByProjectId,
  getSensorsStatusInPlannings,
} from 'services/api';
import S from './PlanningVue.module.scss';
import StatusSensor from './StatusSensor';
import Bouton from '../../UI/Bouton/Bouton';

import * as type_btn from '../../../ressources/glossaires/glossaire_type_de_bouton';
interface SensorTask {
  id: string;
  name: string;
  isManual: boolean;
  devui: string;
  mode?: string;
}
interface PlanningSensorListProps {
  tasks: any[];
  projectId?: string | number;
  viewType?: number;
  modes: any;
  autoToManual(task: SensorTask): void;
  manualToAuto(task: SensorTask): void;
  handleSelect(event: any): void;
}

const PlanningSensorList = ({
  tasks,
  projectId,
  viewType,
  modes,
  autoToManual,
  manualToAuto,
  handleSelect,
}: PlanningSensorListProps) => {
  const [sensorTask, setSensorTask] = useState<SensorTask[]>([]);
  const [sensorsList, setSensorsList] = useState([]);
  const [sensorsStatus, setSensorsStatus] = useState<{
    [key: string]: {
      status: string;
      datetime: string;
      last_command_status?: string;
    };
  }>({});

  const refreshSensorList = async () => {
    if (!projectId) return;
    try {
      const response = await getAllCapteurByProjectId({
        projects_id: [projectId],
      });
      setSensorsList(response.data.sensors_list);
    } catch (error) {
      console.error('Erreur lors du rafraîchissement des capteurs:', error);
    }
  };

  useEffect(() => {
    if (tasks.length <= 0 || !projectId) return;
    const task = tasks.find((t) => t.state !== 2);
    const sensorsId = task.sensors_list.split(',');
    const fetchSensorData = async () => {
      let sensors = sensorsList;
      if (sensorsList.length <= 0) {
        try {
          await getAllCapteurByProjectId({
            projects_id: [projectId],
          }).then((response) => (sensors = response.data.sensors_list));
          setSensorsList(sensors);
        } catch (error) {
          console.error('Failed to fetch sensors:', error);
          setSensorsList([]);
        }
      }
      const updatedSensors = sensors
        .filter((sensor: any) => sensorsId.includes('' + sensor.sensor_id))
        .map((sensor: any) => {
          let sensorState = {
            id: sensor.sensor_id,
            name: sensor.sensor_name,
            devui: sensor.remarks,
            isManual: false,
            mode: '',
          };
          if (viewType === 5 || viewType === 6) {
            const taskLinkedToSensor = tasks.find((t) => {
              return t.id_arguments[1].Value.includes('' + sensor.remarks);
            });
            sensorState.mode = taskLinkedToSensor?.id_arguments[0].Value;
            sensorState.isManual = taskLinkedToSensor?.state === 2;
          }
          return sensorState;
        });
      setSensorTask(updatedSensors);

      // Fetch sensors status
      if (updatedSensors.length > 0) {
        try {
          const sensorIds = updatedSensors.map((s: any) => parseInt(s.id));
          const statusResponse = await getSensorsStatusInPlannings({
            sensor_ids: sensorIds,
          });
          const statusMap: {
            [key: string]: {
              status: string;
              datetime: string;
              last_command_status?: string;
            };
          } = {};
          statusResponse.data.sensors_status.forEach((s: any) => {
            statusMap[s.sensor_id] = {
              status: s.status,
              datetime: s.datetime,
              last_command_status: s.last_command_status,
            };
          });
          setSensorsStatus(statusMap);
        } catch (error) {
          console.error('Failed to fetch sensors status:', error);
        }
      }
    };
    fetchSensorData();
  }, [tasks, projectId]);

  const displaySensors = () => {
    const planned = sensorTask
      .filter((sensor) => !sensor.isManual)
      .map((sensor) => {
        const sensorStatus = sensorsStatus[sensor.id];

        // Si aucun statut reçu, on affiche "Pas de réponse" sans couleur ni date
        if (!sensorStatus) {
          return (
            <div key={sensor.id} className={S.sensorItem}>
              <div
                className={`${S.sensorArrow} ${S.arrowDown}`}
                onClick={(e) => {
                  e.stopPropagation();
                  autoToManual(sensor);
                }}
                title="Cliquez pour passer en mode Manuel"
              >
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M7 10l5 5 5-5z" />
                </svg>
              </div>
              <div className={S.sensorInfo}>
                <span className={S.sensorName}>{sensor.name}</span>
                <StatusSensor sensorId={sensor.id} />
              </div>
            </div>
          );
        }

        const statusValue = sensorStatus.status;

        // Trouver le mode correspondant au status retourné par l'API
        const modeObj = modes.find(
          (m: any) =>
            String(m.name) === String(statusValue) ||
            String(m.id) === String(statusValue)
        );

        const statusColor = modeObj?.color;
        const statusName = modeObj?.name || statusValue;
        const statusDatetime = sensorStatus.datetime;

        return (
          <div key={sensor.id} className={S.sensorItem}>
            <div
              className={`${S.sensorArrow} ${S.arrowDown}`}
              onClick={(e) => {
                e.stopPropagation();
                autoToManual(sensor);
              }}
              title="Cliquez pour passer en mode Manuel"
            >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M7 10l5 5 5-5z" />
              </svg>
            </div>
            <div className={S.sensorInfo}>
              <span className={S.sensorName}>{sensor.name}</span>
              <StatusSensor
                sensorId={sensor.id}
                color={statusColor}
                modeName={statusName}
                datetime={statusDatetime}
                lastCommandStatus={sensorStatus.last_command_status}
              />
            </div>
          </div>
        );
      });
    const manual = sensorTask
      .filter((sensor) => sensor.isManual)
      .map((sensor) => {
        const sensorStatus = sensorsStatus[sensor.id];

        if (!sensorStatus) {
          return (
            <div key={sensor.id} className={`${S.sensorItem} ${S.manualMode}`}>
              <div
                className={`${S.sensorArrow} ${S.arrowUp}`}
                onClick={() => {
                  manualToAuto(sensor);
                }}
                title="Cliquez pour passer en mode Plannifié"
              >
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M7 14l5-5 5 5z" />
                </svg>
              </div>
              <div className={S.sensorInfo}>
                <span>{sensor.name}</span>
                <StatusSensor sensorId={sensor.id} />
              </div>
              <div className={S.sensorControls}>
                <select
                  className={S.modeSelect}
                  style={{
                    backgroundColor: (() => {
                      const selectedModeObj = modes.find(
                        (m: any) => String(m.id) === String(sensor.mode)
                      );
                      return selectedModeObj?.color || '#ccc';
                    })(),
                    borderColor: (() => {
                      const selectedModeObj = modes.find(
                        (m: any) => String(m.id) === String(sensor.mode)
                      );
                      return selectedModeObj?.color || '#ccc';
                    })(),
                    color: 'white',
                  }}
                  value={sensor.mode}
                  onChange={(event) => handleSelect(event)}
                  name={sensor.devui}
                >
                  {modes.map((mode: any) => (
                    <option key={mode.id} value={mode.id}>
                      {mode.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          );
        }

        const statusValue = sensorStatus.status;

        // Trouver le mode correspondant au status retourné par l'API
        const modeObj = modes.find(
          (m: any) =>
            String(m.name) === String(statusValue) ||
            String(m.id) === String(statusValue)
        );

        const statusColor = modeObj?.color;
        const statusName = modeObj?.name || statusValue;
        const statusDatetime = sensorStatus.datetime;

        return (
          <div key={sensor.id} className={`${S.sensorItem} ${S.manualMode}`}>
            <div
              className={`${S.sensorArrow} ${S.arrowUp}`}
              onClick={() => {
                manualToAuto(sensor);
              }}
              title="Cliquez pour passer en mode Plannifié"
            >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M7 14l5-5 5 5z" />
              </svg>
            </div>
            <div className={S.sensorInfo}>
              <span>{sensor.name}</span>
              <StatusSensor
                sensorId={sensor.id}
                color={statusColor}
                modeName={statusName}
                datetime={statusDatetime}
                lastCommandStatus={sensorStatus.last_command_status}
              />
            </div>
            <div className={S.sensorControls}>
              <select
                className={S.modeSelect}
                style={{
                  backgroundColor: (() => {
                    const selectedModeObj = modes.find(
                      (m: any) => String(m.id) === String(sensor.mode)
                    );
                    return selectedModeObj?.color || '#ccc';
                  })(),
                  borderColor: (() => {
                    const selectedModeObj = modes.find(
                      (m: any) => String(m.id) === String(sensor.mode)
                    );
                    return selectedModeObj?.color || '#ccc';
                  })(),
                  color: 'white',
                }}
                value={sensor.mode}
                onChange={(event) => handleSelect(event)}
                name={sensor.devui}
              >
                {modes.map((mode: any) => (
                  <option key={mode.id} value={mode.id}>
                    {mode.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        );
      });
    if (sensorTask.length === 0) {
      return <div className={S.emptyState}>Aucun capteur disponible</div>;
    }
    return (
      <>
        <div className={S.sensorListSection}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <span className={S.refreshButton}>
              <Bouton
                type={type_btn.actualiser}
                rond={true}
                cliquer={refreshSensorList}
                hoverText="Rafraîchir"
                title="Rafraîchir la liste des capteurs"
                style={{ backgroundColor: '#070708ff', color: 'white' }}
              />
            </span>
            <h3>Mode plannifié</h3>
          </div>
          <div className={S.infoNote}>
            <span className={S.infoIcon}>i</span>
            <span className={S.infoText}>
              Le planning hebdomadaire s'applique aux éléments de cette liste.
            </span>
          </div>
          {planned.length > 0 ? (
            planned
          ) : (
            <div className={S.emptyState}>Aucun capteur en mode plannifié</div>
          )}
        </div>
        <div className={S.sensorListSection}>
          <h3>Mode manuel</h3>
          {manual.length > 0 ? (
            manual
          ) : (
            <div className={S.emptyState}>Aucun capteur en mode manuel</div>
          )}
        </div>
      </>
    );
  };

  return <>{displaySensors()}</>;
};

export default PlanningSensorList;
